import React from 'react'
import { Helmet } from 'react-helmet'
import { useTranslation } from 'react-i18next'

const TITLE_SEPARATOR = ' — '

const PageTitle = ({ keys = [], title }) => {
  const { t, i18n } = useTranslation(undefined, { bindI18nStore: 'added removed' })

  const resolvedTitle = React.useMemo(() => {
    if (title) {
      return title
    }

    if (!keys.length || !keys.every((key) => i18n.exists(key))) {
      return null
    }

    const parts = keys.map((key) => t(key)).filter(Boolean)

    return parts.length ? parts.join(TITLE_SEPARATOR) : null
  }, [title, keys, t, i18n, i18n.language])

  if (!resolvedTitle) {
    return null
  }

  return (
    <Helmet defer={false}>
      <title key={resolvedTitle}>{resolvedTitle}</title>
    </Helmet>
  )
}

export default PageTitle
export { TITLE_SEPARATOR }
